import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/components/index'
import indexAnimate from '@/components/index-animate'
import latestNews from '@/components/latestNews'
import latestNewsDetail from '@/components/latestNewsDetail'
import latestProduct from '@/components/latest_product'
import talent_zhaopin from '@/components/talent_zhaopin'
import talent_zhaopinDetail from '@/components/talent_zhaopinDetail'
import index from '../../src/pages/index/index'// 首页页面
import login from '../../src/pages/login/index' // 登录页面
import onlineMall from '../../src/pages/onlineMall/onlineMallList/index' // 网上商城列表页面
import onlineMallDetail from '../../src/pages/onlineMall/onlineMallDetail/index' // 网上商城列表详情

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'index',
			component: index
		},
		{
			path: '/about',
			name: 'about',
			component: indexAnimate
		},
		/*{
		  path: '/news',
		  name: 'latestNews',
		  component: latestNews
		},
		 {
		  path: '/news/:id',
		  name: 'latestNews-detail',
		  component: latestNewsDetail
		},
		{
		  path: '/news/product/:id',
		  name: 'latestProduct',
		  component: latestProduct
		},*/
		{
			path: '/recruit',
			name: 'talent_zhaopin',
			component: talent_zhaopin
		},
		{
			path: '/recruit/:id',
			name: 'talent_zhaopin-detail',
			component: talent_zhaopinDetail
		},
		{
			path: '/login',
			name: 'login',
			component: login
		},
		{
			path: '/onlineMall',
			name: 'onlineMall',
			component: onlineMall,// 网上商城列表页面
			meta:{
			    keepAlive:true
			}
		},
		{
			path: '/onlineMallDetail/:id',
			name: 'onlineMallDetail',
			component: onlineMallDetail,// 网上商城列表详情
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js